import { render, staticRenderFns } from "./FieldsetNameRubyParts.vue?vue&type=template&id=6ba26648&scoped=true"
import script from "./FieldsetNameRubyParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetNameRubyParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetNameRubyParts.vue?vue&type=style&index=0&id=6ba26648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba26648",
  null
  
)

export default component.exports